import { WebhooksApiClient } from '@fourthwall/services/dist/WebhooksApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useWebhookTypesQuery = createQueryHook(WebhooksApiClient.getWebhookTypes, {
  queryKey: ['webhookTypes'],
})
